import { useEffect, useState } from "react";
import { SunIcon, MoonIcon } from "@heroicons/react/24/solid";

export default function ThemeToggle() {
  const [isDark, setIsDark] = useState<boolean>(() => {
    const theme = localStorage.getItem("theme");
    if (theme) {
      return theme === "dark";
    }
    return window.matchMedia("(prefers-color-scheme: dark)").matches;
  });

  useEffect(() => {
    const root = window.document.documentElement;
    if (isDark) {
      root.classList.add("dark");
      localStorage.setItem("theme", "dark");
    } else {
      root.classList.remove("dark");
      localStorage.setItem("theme", "light");
    }
  }, [isDark]);

  const toggleTheme = () => {
    setIsDark(!isDark);
  };

  return (
    <div className="flex items-center justify-center">
      <button
        onClick={toggleTheme}
        className="relative w-12 h-6 bg-gray-300 dark:bg-gray-600 rounded-full focus:outline-none transition-colors"
      >
        <div
          className={`absolute top-0.5 left-0.5 h-5 w-5 bg-white rounded-full shadow transform transition-transform duration-300 ${
            isDark ? "translate-x-6" : ""
          }`}
        />
        <SunIcon className="absolute left-1 top-1 h-4 w-4 text-yellow-500" />
        <MoonIcon className="absolute right-1 top-1 h-4 w-4 text-gray-900" />
      </button>
    </div>
  );
}
